import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormLabel,
  FormControl,
  Link,
  TextField,
  Typography,
  Card,
  AppBar,
  Toolbar,
  IconButton,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { loginSuccess, logout } from "../redux/features/auth/authSlice";
import { toast } from "react-toastify";
import userApi from "../api/userApi";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

function LoginPage() {
  // ---- form state
  const [taxId, setTaxId] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [taxIdError, setTaxIdError] = React.useState(false);
  const [taxIdErrorMessage, setTaxIdErrorMessage] = React.useState("");
  const [userNameError, setUserNameError] = React.useState(false);
  const [userNameErrorMessage, setUserNameErrorMessage] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState("");
  const dispatch = useDispatch();

  // ---- slider state
  const slides = [
    "./Xuathoadon01.jpg",
    "./Xuathoadon02.jpg",
    "./Xuathoadon03.jpg",
    "./Xuathoadon04.jpg",
    "./Xuathoadon05.jpg",
  ];
  const [slideIdx, setSlideIdx] = useState(0);

  useEffect(() => {
    const taxId = localStorage.getItem("taxId");
    if (taxId) setTaxId(taxId);

    const token = sessionStorage.getItem("token");
    if (token) {
      sessionStorage.removeItem("token");
      dispatch(logout());
    }
  }, [dispatch]);

  useEffect(() => {
    const t = setInterval(() => {
      setSlideIdx((i) => (i + 1) % slides.length);
    }, 4000);
    return () => clearInterval(t);
  }, [slides.length]);

  const prev = () =>
    setSlideIdx((i) => (i - 1 + slides.length) % slides.length);
  const next = () => setSlideIdx((i) => (i + 1) % slides.length);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateInputs()) return;
    try {
      const response = await userApi.login({
        taxid: taxId,
        username: username,
        password: password,
      });
      if (response.success) {
        localStorage.setItem("taxId", taxId);
        dispatch(
          loginSuccess({
            user: response.data.userInfor,
            roles: response.data.userRoles,
            customerInfor: response.data.customerInfor,
            customerParentInfor: response.data.customerParentInfor,
          }),
        );
      } else {
        toast.error(response.message || "Đăng nhập thất bại.");
      }
    } catch (error) {
      toast.error(error.message);
      console.log("Login API call failed:", error);
    }
  };

  const validateInputs = () => {
    let isValid = true;
    if (!taxId) {
      setTaxIdError(true);
      setTaxIdErrorMessage("Mã đơn vị không được để trống");
      isValid = false;
    } else {
      setTaxIdError(false);
      setTaxIdErrorMessage("");
    }
    if (!username) {
      setUserNameError(true);
      setUserNameErrorMessage("Tài khoản không được để trống");
      isValid = false;
    } else {
      setUserNameError(false);
      setUserNameErrorMessage("");
    }
    if (!password || password.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage("Mật khẩu phải có ít nhất 6 ký tự.");
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage("");
    }
    return isValid;
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar
        position="static"
        component="div"
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
          "& .MuiToolbar-root": { color: "text.primary" },
          "& .MuiButton-root": { color: "inherit" },
          position: "absolute",
          top: 0,
          right: 0,
          left: 0,
        }}
      >
        <Toolbar sx={{ px: { xs: 2, md: 6 }, background: "#D3E3F8" }}>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
          >
            <img
              src="Relisoft1024_ngang.svg"
              alt="Logo"
              style={{ height: "40px", marginRight: "10px" }}
            />
          </Typography>

          <Box sx={{ display: { xs: "none", md: "flex" }, gap: 1 }}>
            <Button component={Link} href="https://relipos.com/">
              Giới thiệu
            </Button>
            <Button component={Link} href="https://relipos.com/ho-tro/">
              Hướng dẫn
            </Button>
            <Button component={Link} href="https://www.youtube.com/@Relisoft">
              Video
            </Button>
            <Button component={Link} href="https://relipos.com/lien-he/">
              Liên hệ
            </Button>
          </Box>

          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
          >
            <img
              src="Relisoft1024_ngang.svg"
              alt="Logo"
              style={{ height: "30px", marginRight: "10px" }}
            />
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          marginTop: "80px",
          paddingLeft: "32px",
          paddingRight: "32px",
        }}
      >
        <Box
          sx={{
            position: "relative",
            flex: { xs: "0 0 auto", md: 1 },
            height: { xs: 240, md: "90vh" },
            overflow: "hidden",
          }}
        >
          {slides.map((src, i) => (
            <Box
              key={src}
              sx={{
                position: "absolute",
                inset: 0,
                backgroundImage: `url(${src})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                transition: "opacity 600ms ease",
                opacity: i === slideIdx ? 1 : 0,
              }}
            />
          ))}

          {/* Nút prev/next */}
          <IconButton
            aria-label="prev"
            onClick={prev}
            sx={{
              position: "absolute",
              top: "50%",
              left: 12,
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.35)",
              color: "#fff",
              "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
            }}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>
          <IconButton
            aria-label="next"
            onClick={next}
            sx={{
              position: "absolute",
              top: "50%",
              right: 12,
              transform: "translateY(-50%)",
              bgcolor: "rgba(0,0,0,0.35)",
              color: "#fff",
              "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
            }}
          >
            <ArrowForwardIosIcon fontSize="small" />
          </IconButton>

          {/* Dots */}
          <Box
            sx={{
              position: "absolute",
              bottom: 16,
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: 1,
            }}
          >
            {slides.map((_, i) => (
              <Box
                key={i}
                onClick={() => setSlideIdx(i)}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor:
                    i === slideIdx ? "common.white" : "rgba(255,255,255,0.6)",
                  cursor: "pointer",
                }}
              />
            ))}
          </Box>
        </Box>

        {/* RIGHT: login form */}
        <Box
          sx={{
            flex: { xs: "0 0 auto", md: 1 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 2, md: 6 },
            py: { xs: 3, md: 0 },
          }}
        >
          <Card
            variant="outlined"
            sx={{
              width: "100%",
              maxWidth: 440,
              p: { xs: 3, md: 4 },
              boxShadow: { md: 3 },
              borderRadius: 3,
            }}
          >
            <Typography
              component="h1"
              variant="h4"
              sx={{
                width: "100%",
                fontSize: "clamp(2rem, 4vw, 2.15rem)",
                mb: 2,
              }}
            >
              Đăng nhập
            </Typography>

            <Box
              component="form"
              onSubmit={handleSubmit}
              noValidate
              sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
              <FormControl>
                <FormLabel htmlFor="taxId">Mã đơn vị</FormLabel>
                <TextField
                  error={taxIdError}
                  helperText={taxIdErrorMessage}
                  id="taxId"
                  type="text"
                  name="taxId"
                  placeholder="Mã đơn vị"
                  autoComplete="organization"
                  required
                  fullWidth
                  variant="outlined"
                  color={taxIdError ? "error" : "primary"}
                  value={taxId}
                  onChange={(e) => setTaxId(e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel htmlFor="username">Tài khoản</FormLabel>
                <TextField
                  error={userNameError}
                  helperText={userNameErrorMessage}
                  id="username"
                  type="text"
                  name="username"
                  placeholder="Tài khoản"
                  autoComplete="username"
                  required
                  fullWidth
                  variant="outlined"
                  color={userNameError ? "error" : "primary"}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel htmlFor="password">Mật khẩu</FormLabel>
                <TextField
                  error={passwordError}
                  helperText={passwordErrorMessage}
                  name="password"
                  placeholder="••••••"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  required
                  fullWidth
                  variant="outlined"
                  color={passwordError ? "error" : "primary"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>

              <Button
                type="submit"
                variant="contained"
                onClick={validateInputs}
                sx={{
                  alignSelf: "center", // canh giữa theo trục ngang của form
                  width: 200, // cố định bề rộng (tuỳ chỉnh)
                  mt: 1,
                  background: "#2569ED",
                }}
              >
                Đăng nhập
              </Button>

              {/* Quên mật khẩu */}
              <Box sx={{ width: "100%", textAlign: "center", mt: 1 }}>
                <Link href="/forgot-password" underline="always">
                  Quên mật khẩu?
                </Link>
              </Box>
            </Box>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}

export default LoginPage;
